<template lang="pug">
.g
	loader(v-show='!isLoaded')
	.g__c.g__c--lg8(v-show='isLoaded')
		.g
			.g__c
				.headerUtil.headerUtil--leftAligned
					h2.headerUtil__heading(v-if='this.$store.state.searchQuery.searchTerm') Search Results for '{{ this.$store.state.searchQuery.searchTerm }}'
				search-box(@submitSearch='setQuery' @setPage='setPage')
		.g
			.g__c
				search-results
				search-pagination(@submitPage='setPage' :pagination.sync="setPage" ref="bottomPagination")
	.g__c.g__c--lg4


//- #search-app.section__inner
//-   loader(v-show='!isLoaded')
//-   .section__main(v-show='isLoaded')
//-     .composition.composition--padded-sm.composition--collapse
//-     .composition.composition--padded.composition--collapse
//-       search-box(v-if='shouldHeaderBeShown' @submitsearch='setQuery')
//-       search-results
//-       search-pagination(v-if='shouldHeaderBeShown' @submitpage='setPage')

</template>

<script>
    import SearchBox from './components/SearchBox'
    import SearchFilters from './components/SearchFilters'
    import SearchResults from './components/SearchResults'
    import SearchPagination from './components/SearchPagination'
    import Loader from './components/Loader'

    export default {
        name: "SearchApp",
        components: {
            Loader,
            SearchBox,
            SearchFilters,
            SearchResults,
            SearchPagination
        },
        methods: {
            setQuery(data) {
                // sets the search text
                this.changeOnlyOneParam("q", data);
                this.changeOnlyOneParam("p", 0);
                this.$store.commit('setQuery', data);
                this.$store.commit('setCurrentPage', 0);
                this.executeSearch();
            },
            setPage(data) {
                // sets the page from pagination
                this.changeOnlyOneParam("p", data);
                this.$store.commit('setPageIndex', data);
                this.executeSearch();
            },
            setFilters(data) {
                // sets the filters
                this.changeOnlyOneParam("c", this.getFilterQuerystring(data));
                this.$store.commit('setFilters', data);
                this.executeSearch();
            },
            executeSearch() {
                this.isLoaded = false;

                postData(this.$store.state.settings.searchUrl, this.$store.state.searchQuery)
                    .then(response => {
                        this.$store.commit('setResults', response);

                        if (this.selectedPageIndex > this.results.totalPages - 1) {
                            this.$store.commit('setPageIndex', 0);
                        }
                    })
                    .finally(() => this.isLoaded = true);
            },
            changeOnlyOneParam(paramName, changeTo) {
                var params = JSON.parse(JSON.stringify(this.$route.query));
                params[paramName] = changeTo;

                this.$router.replace({
                    query: params
                }).catch(() => {});
            },
            getFilterQuerystring(filters) {
                var ids = [];
                filters.forEach(function (parent) {
                    var set = parent.filters.filter(c => c.selected == true).map(a => a.id);

                    if (set.length > 0) {
                        ids.push(set);
                    }
                });

                return ids.join(',');
            }

        },
        computed: {
            results() {
                return this.$store.state.results;
            },
            searchQuery() {
                return this.$store.state.searchQuery;
            },
            selectedPageIndex() {
                return this.$store.state.selectedPageIndex;
            },
            shouldHeaderBeShown() {
                return !this.$root.hideQueryTextbox;
            },
            shouldFiltersBeShown() {
                return !this.$root.hideFilters === true;
            }
        },
        data: function () {
            return {
                isLoaded: false
            }
        },
        created() {
            // Get default settings, allow for overrides in the app markup
            var settings = this.$store.state.settings;

            settings.searchUrl = this.$root.searchUrl;

            // Conditionally override default values for text
            if (this.$root.headerText) {
                settings.headerText = this.$root.headerText;
            }

            if (this.$root.searchPlaceholder) {
                settings.searchPlaceholder = this.$root.searchPlaceholder;
            }

            if (this.$root.searchButtonText) {
                settings.searchButtonText = this.$root.searchButtonText;
            }

            if (this.$root.filterText) {
                settings.filterText = this.$root.filterText;
            }

            if (this.$root.filterButtonText) {
                settings.filterButtonText = this.$root.filterButtonText;
            }

            // Set data to store
            this.$store.commit('setSettings', settings);
            this.$store.commit('setSearchIndex', this.$root.searchIndex);
            this.$store.commit('setPageSize', this.$root.pageSize);
            this.$store.commit('setFilterGroups', this.$root.filterGroups);
            this.$store.commit('setShowContentType', this.$root.showContentType);

            // Check URL to see if any parameters are set
            if (this.$route.query.q) {
                this.$store.commit('setQuery', this.$route.query.q);
            }

            // Check if the query has been hard-coded in the embed tag
            if (this.$root.searchTerm) {
                this.$store.commit('setQuery', this.$root.searchTerm);
            } else {
                // Check URL to see if any parameters are set
                if (this.$route.query.q) {
                    this.$store.commit('setQuery', this.$route.query.q);
                }
            }

            if (this.$route.query.p) {
                this.$store.commit('setPageIndex', this.$route.query.p);
            }
            // filters set in querystring must be set after initial query because the filters have to come from the server first.
            this.executeSearch();
        }
    }

    async function postData(url = '', data = {}) {

        var body = JSON.stringify(data);

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body
        });
        return response.json();
    }
</script>

<style lang="scss">

</style>